import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useAuth, useLang } from "@/lib/api";

// Accès rapide à « Mon espace » (Business Center), présent sur toutes les pages
// mais visible UNIQUEMENT pour un utilisateur connecté avec le rôle entreprise.
// Même style/position que le bouton flottant admin (les deux rôles s'excluent,
// donc pas de chevauchement possible).
export default function EntrepriseFlottant() {
  const { user } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  if (!user || user.role !== "entreprise") return null;
  return (
    <button
      onClick={() => nav("/espace-entreprise")}
      data-testid="entreprise-flottant"
      style={{
        position: "fixed", bottom: 22, left: 22, height: 44, padding: "0 16px",
        display: "inline-flex", alignItems: "center", gap: 8, borderRadius: 24,
        background: "var(--navy)", color: "#fff", border: "1.5px solid var(--gold)",
        fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 13.5,
        cursor: "pointer", boxShadow: "0 6px 18px rgba(0,0,0,.22)", zIndex: 60,
        transition: "transform .15s",
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = "scale(.95)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
      aria-label={t("mon_espace")}
    >
      <Building2 size={17} color="var(--gold)" /> {t("mon_espace")}
    </button>
  );
}
